import MainComponent from "components/Main";

import { ReactComponent as CloseIcon } from 'icons/components/close.svg';

import './index.less';
import './themes/default.less';

export default class FilterBlock extends MainComponent {
    onCloseFilterItem(ind) {
        const { filter, changeState } = this.props;
        const newFilter = [...filter.filter((_, i) => i !== ind)];

        changeState(newFilter);
    }

    renderFilterItem(it, ind) {
        let titleText = "";
        const { key, text } = it;

        const map = {
            status: `Статус:`,
            age: `Возраст:`,
            sex: `Пол:`,
            clinic: `Клиника:`,
            reason: `Причина обращения:`,
            month: `Месяц рождения:`,
            recommendationType: `Источник регистрации:`,
            birthDate: `Дата рождения:`,
            doctor: `Доктор:`,
            dateVisits: `Даты визитов:`,
            dateLastVisit: `Последний визит:`,
            coordinator: "Координатор:"
        };

        titleText = text;

        return (<div key={ind} className="filterCell flex gap8">
            <div className="text p1 ">
                <div className="black2">{map[key]} <span className="gray1">{titleText}</span></div>
            </div>
            <div className="flex centerV hand" style={{ width: "15px" }} onClick={this.onCloseFilterItem.bind(this, ind)} >
                <CloseIcon className="closeIcon" />
            </div>
        </div>);
    }

    render() {
        const { filter } = this.props;

        return (<div className="filterBlock flex gap8">
            {filter.map((it, i) => {
                return this.renderFilterItem(it, i);
            })}
        </div>);
    }

}
